import $ from 'jquery';
import { $win, $body } from '../utils/globals';
import isMobile from '../utils/isMobile';

function navClick() {
    $('.nav').on('click', 'a', function(e) {
        let parentEl = $(this).closest('li');
        let subMenu = $(this)
            .closest('li')
            .children('ul');

        parentEl.siblings().removeClass('is-hovered');

        if (!parentEl.hasClass('is-hovered') && isMobile.any() && $win.width() <= 1024 && subMenu.length > 0) {
            e.preventDefault();

            parentEl.addClass('is-hovered');
        }
    });
}

export default navClick;
